import { Button, Form } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React from 'react';

import {
    renderInput,
    renderPasswordField,
    renderSelect,
    renderTextField,
  } from "../../component/form/form";
const ModalForms = ({title,visible,cancel,ok,api,refresh,name,label,dropdown}) => {
    
  const [form] = Form.useForm();
  const onFinish = async (values) => {
    const code = await api(values);
    if (code === 201) {
        form.resetFields();
        refresh();

        cancel();
    }
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
  };
  const option = [
    { value: "minor", label: "Minor" },
    { value: "major", label: "Major" },
  ];
    return ( 
        <Modal
        title={title}
        centered
        visible={visible}
        width={700}
        onCancel={cancel}
        onOk={ok}
      >
        <Form
          name="basic"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ alignSelf: "center" }}
          requiredMark={false}
          form={form}
          autoComplete={false}
        >
            {dropdown ?
            
          renderSelect(
            name,
            label,
            [{ required: true }],
            "Select Version",
            option,
            "none"
          )
            :
            
                renderInput(name, label, [
                    { required: true, message: "This field is required!" },
                ])
            }
          {renderTextField("remark", "Remark", [
            { required: true, message: "This field is required!" },
          ])}
          {renderPasswordField("password", "Password", [
            { required: true, message: "This field is required!" },
          ])}

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
     );
}
 
export default ModalForms;